import { UnicodeCharacterConstants } from "constants/unicode-character-constants";

const AppNameTm = `NFPA LiNK${UnicodeCharacterConstants.Registered}`;

const AppNameWithHtml = `NFPA LiNK<sup>${UnicodeCharacterConstants.Registered}</sup>`;

const AppName = `NFPA LiNK`;

const NfpaWithHtml = `NFPA<sup>${UnicodeCharacterConstants.Registered}</sup>`;

const CasiWithHtml = `CASI<sup>${UnicodeCharacterConstants.TM}</sup>`;

const Casi = `CASI™`;

export {
    AppNameTm,
    AppNameWithHtml,
    AppName,
    NfpaWithHtml,
    CasiWithHtml,
    Casi,
};
